import { DatePicker, TimePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import _ from "lodash";
import { useEffect, useState } from "react";

interface Props {
  id: string;
  value: any;
  handleFormItem: any;
  mode?: "date" | "time";
}

export default function DatePickerInput(props: Props) {
  const { id, value, handleFormItem, mode = "date" } = props;
  const [date, setDate] = useState(() => {
    const defaultDate = value ? new Date(value) : undefined;
    if (_.isDate(defaultDate) && !isNaN(defaultDate.getTime())) {
      return defaultDate;
    }
    return undefined;
  });

  useEffect(() => {
    const newDate = value ? new Date(value) : undefined;
    if (_.isDate(newDate) && !isNaN(newDate.getTime())) {
      setDate(newDate);
    }
  }, [value]);

  if (mode === "time") {
    return (
      <TimePicker
        className="w-full !rounded-lg bg-white"
        value={date ? dayjs(date) : null}
        onChange={(datejsdate) => {
          if (datejsdate?.isValid()) {
            handleFormItem(datejsdate.toISOString(), id);
          }
        }}
      />
    );
  }

  return (
    <DatePicker
      className="w-full !rounded-lg bg-white"
      value={date ? dayjs(date) : null}
      onChange={(datejsdate) => {
        if (datejsdate?.isValid()) {
          handleFormItem(datejsdate.toISOString(), id);
        }
      }}
    />
  );
}
